import { makeStyles } from '@material-ui/core';
import colors from 'styles/colors';
import themeStyle from 'styles/theme';

const dialogWrapperStyles = makeStyles({
  title: {
    ...themeStyle.typography.smSemibold,
    color: colors.gray[900]
  },
  value: {
    ...themeStyle.typography.smMedium,
    color: colors.gray[700]
  }
});

export default dialogWrapperStyles;
